module.exports = __webpack_public_path__ + "static/media/gearlogbook-app-icon.c20708fa.png";